import CustomChip from "../../components/shared/CustomChip";
import SelectThemeColor from "../../components/shared/SelectThemeColor";
import { useSelector } from "react-redux";
import { getFieldValue } from "../booking-instruments/helpers";

const accessControlStatus = {
  allowed: "Allowed",
  restricted: "Restricted",
  trainingRequired: "Training Required",
  unknown: "Unknown"
};

const BookingAccessControlRender = (params) => {

  const storeUser = useSelector((store) => store.user);

  const getTextColor = (status) => {
    switch (status) {
      case accessControlStatus.allowed:
        return SelectThemeColor.availability.color.qualified;
      case accessControlStatus.restricted:
      case accessControlStatus.trainingRequired:
        return SelectThemeColor.availability.color.not_qualified;
      default:
        return SelectThemeColor.availability.color.unknown;
    }
  };

  const getBGColor = (status) => {
    switch (status) {
      case accessControlStatus.allowed:
        return SelectThemeColor.availability.background.available;
      case accessControlStatus.restricted:
      case accessControlStatus.trainingRequired:
        return SelectThemeColor.availability.background.booking;
      default:
        return SelectThemeColor.availability.background.unknown;
    }
  };

  const cidmGroupName = getFieldValue(params?.data, "cidm_group_name");
  const isBookingControlled = getFieldValue(params?.data, "is_booking_controlled") === "true" || cidmGroupName;
  const bookableForUsers = getFieldValue(params?.data, "bookable_for_users");

  const userCidmGroups = storeUser?.cidmGroups

  const userHasAccess = cidmGroupName
    ? userCidmGroups?.some(userCidmGroup => (cidmGroupName && cidmGroupName.toLowerCase() === userCidmGroup.toLowerCase()))
    : bookableForUsers?.some(
      user => user === storeUser?.id || user === storeUser?.user
    );

  let status = accessControlStatus.unknown;

  if (isBookingControlled) {
    if (userHasAccess) {
      status = accessControlStatus.allowed;
    } else if (cidmGroupName) {
      status = accessControlStatus.trainingRequired;
    } else {
      status = accessControlStatus.restricted;
    }
  } else {
    status = accessControlStatus.allowed;
  }

  const handleClick = (event) => {
    event.stopPropagation();

    if (status === accessControlStatus.trainingRequired && cidmGroupName) {
      const cidmGroupCidmUrl = getFieldValue(params?.data, "cidm_group_cidm_url");
      const cidmGroupMoreInfoUrl = getFieldValue(params?.data, "cidm_group_more_info_url");

      const openCidmDialogEvent = new CustomEvent('openCidmDialog', {
        detail: {
          name: cidmGroupName || '',
          url: cidmGroupCidmUrl || '',
          info: cidmGroupMoreInfoUrl || '',
        }
      });
      document.dispatchEvent(openCidmDialogEvent);
    }
  };

  return <CustomChip
    text={status}
    color={getTextColor(status)}
    bgColor={getBGColor(status)}
    bold
    style={{ cursor: status === accessControlStatus.trainingRequired ? 'pointer' : 'default' }}
    onClick={handleClick}
  />;
};

export default BookingAccessControlRender;
